import { object, boolean } from '@gogame/schemas';

export const organicSettingsSchema = object(
  {
    visible: boolean(),
  },
  'organic'
).default({
  visible: false,
});
